export default "__VITE_ASSET__B$uLS2O7__"